export const buildSummedRentRoll = function (tab) {
    return {
        'first-row': {
            valueCells: [
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2})}%`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {empty: true},
                {empty: true},
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const annualRent = tabs['marketing-tab'].tables['sumed-rent-roll'].rows[rowIdentifier].valueCells[3].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const occupiedSpace = tabs[tab].tables['sumed-general-information'].rows['first-row'].valueCells[2].getComputedValue(tabs).internalValue;
                        const value = parseFloat(annualRent / occupiedSpace);
                        const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {empty: true},
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs) {
                        let sum = 0;
                        const rows = tabs[tab].tables['detailed-information'].rows;
                        Object.keys(rows).forEach((key) => {
                            sum = rows[key].valueCells[14].getComputedValue(tabs, key)['internalValue'] ? sum + parseFloat(rows[key].valueCells[14].getComputedValue(tabs, key)['internalValue']) : sum;
                        });
                        if (sum <= 0)
                            return {internalValue: 0, displayValue: '-'};
                        return {internalValue: sum, displayValue: `$${sum.toLocaleString(undefined, {maximumFractionDigits: 2})}`};
                    },
                },
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs) {
                        const detailAnnualRent = tabs[tab].tables['sumed-detailed-information'].rows['first-row'].valueCells[14].getComputedValue(tabs);
                        const generalSft = tabs[tab].tables['sumed-general-information'].rows['first-row'].valueCells[2].getComputedValue(tabs);
                        if(detailAnnualRent.internalValue && generalSft.internalValue){
                            let value = detailAnnualRent.internalValue / generalSft.internalValue; 
                            return {internalValue: value, displayValue:  `$${value.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits: 2})}`};
                        }
                        return {internalValue: '', displayValue: ''};
                    },
                },
                {empty: true},
                {empty: true},
                {empty: true},
            ]
        },
        'second-row': {
            valueCells: [
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
            ]
        },
        'third-row': {
            valueCells: [
                {
                    editable: false,
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue(tabs, rowIdentifier, precomputedValues) {
                        const value = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                        const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}%`;
                        return {internalValue: value, displayValue: displayValue};
                    },
                },
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
                {empty: true},
            ]
        }
    }
};

export const summedRentRoll = {
    hasNamesColumn: false,
    headerRow: [],
    rows: {}
};